const getSeconds = (duration: string): number => {
  const [hours, minutes] = duration.split(':');
  const calcMinutes = Number(hours) * 60 + Number(minutes);
  return calcMinutes * 60;
};

export default getSeconds;
